import { render, staticRenderFns } from "./AdvancesFrom.vue?vue&type=template&id=20cb2df0&scoped=true&"
import script from "./AdvancesFrom.vue?vue&type=script&lang=js&"
export * from "./AdvancesFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cb2df0",
  null
  
)

export default component.exports